import { render, staticRenderFns } from "./ProductRowItem.vue?vue&type=template&id=6937da6f&scoped=true&"
import script from "./ProductRowItem.vue?vue&type=script&lang=js&"
export * from "./ProductRowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6937da6f",
  null
  
)

export default component.exports